<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->

                    <div class="row margin-top-20">
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="form-header margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="row">
                                    <div class="col-xs-12 col-md-5 col-lg-4">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisar:</h5>
                                            <input type="text" placeholder="Pesquise aqui..." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>    
                                    <div class="col-xs-6 col-md-5 col-lg-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Do dia:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-5 col-lg-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até o dia:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>                                                                
                                    <div class="col-xl-1 col-xs-6">
                                        <div class="submit-field margin-bottom-10">
                                            <h5 class="hidden-xs" style="opacity: 0;">.</h5>
                                            <button class="button color-primary" style="height: 40px; line-height: 100%; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                                                                                       
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>    
                            <h5 v-if="data.itens.length > 0">
                                {{data.total}} resultado(s) encontrado(s).
                            </h5>                                                 
                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12">
                            <div v-show="data.itens.length == 0">
                                <h5 class="margin-bottom-0 empty">
                                    <i class="las la-times"></i>                                          
                                    Nenhum resultado encontrado.
                                </h5>  
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.itens.length > 0 && data.loaded">

                                <table class="child table table-bordered table-bordered-default">
                                    <thead>
                                        <th style="min-width: 50px; width: 50px;">
                                            Id
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Usuário
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Ação
                                        </th>
                                        <th style="min-width: 300px;">
                                            Detalhes
                                        </th>           
                                        <th style="min-width: 100px; width: 100px;">
                                            IP
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Sistema
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            Data/hora
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.cod">
                                            <td data-label="Ud:">
                                                <span>
                                                    <b>
                                                        #{{item.id}}
                                                    </b>
                                                </span>
                                            </td>

                                            <td data-label="Usuário:">
                                                <a >
                                                    {{item.usuario.nome}}
                                                </a>
                                            </td>

                                            <td data-label="Ação:">
                                                <span class="dashboard-status-button color-primary" style="font-weight: bold">
                                                    {{item.acao}}
                                                </span>
                                            </td>

                                            <td data-label="Detalhes:" style="font-weight: 500;">
                                                <a >
                                                    {{item.descricao}}
                                                </a>

                                                <div style="height: 5px; display: block;" v-if="item.descricao && (item.referenciaCod || item.pessoaFisicaCod || item.pessoaFisicaNome)"></div>

                                                <small v-if="item.referenciaCod" style="display: block; color: #666;">
                                                    <b>Id:</b> {{item.referenciaCod}}
                                                </small>
                                                <small v-if="item.pessoaFisicaCod" style="display: block; color: #666;">
                                                    <b>Cód. pessoa:</b> {{item.pessoaFisicaCod}}
                                                </small>
                                                <small v-if="item.pessoaFisicaNome" style="display: block; color: #666;">
                                                    <b>Pessoa física:</b> {{item.pessoaFisicaNome}}
                                                </small>

                                                <div v-if="item.objeto">
                                                    <small style="display: block;">
                                                        <a style="color: blue; text-decoration: underline;" :href="item.objeto.arquivo" target="_blank">Visualizar PDF</a>
                                                    </small>                                                        
                                                </div>
                                            </td>

                                            <td data-label="Detalhes:">
                                                <a >
                                                    {{item.ip}}
                                                </a>
                                            </td>

                                            <td data-label="Sistema:">
                                                <a >
                                                    {{item.dispositivo}}
                                                </a>
                                            </td>                                                    

                                            <td data-label="Data e hora:">
                                                <a >
                                                    {{item.datahora | formatDate}}
                                                </a>
                                            </td>                                                                                                            
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>


                        </div>
                    </div>                
                         
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Logs',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,     
            "data":                 {
                "itens":            {}
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {                 
        get: function(loader) {
            var self        = this;
            console.log("get()");
            if (loader) loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": self.form
                };

                axios.get("api/logs.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    if (loader) loading.hide();
                    if (loader) self.$root.scrollTop();                    
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    if (loader) loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Logs.vue